import React, { useState, useEffect } from "react";
import {
  DataTable,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  Loading,
  InlineNotification,
  FormGroup,
} from "carbon-components-react";
import { Download32 } from "@carbon/icons-react";
import http from "../../http-common";
import { getDocumentTypeDescription } from "../../services/Utils";

const DocumentViewer = ({ applicationUuid }) => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchDocuments();
  }, [applicationUuid]);

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      const response = await http.get(
        `/applications/documents/${applicationUuid}`
      );

      // Transform the data to ensure we only have primitive values for display
      const transformedDocs = response.data.map((doc) => ({
        ...doc,
        id: doc.id?.toString() || "",
        fileName: typeof doc.fileName === "string" ? doc.fileName : "",
        documentType:
          typeof doc.documentType === "string" ? doc.documentType : "",
        uploadDate: doc.uploadDate
          ? new Date(doc.uploadDate).toISOString()
          : "",
        size: typeof doc.size === "number" ? doc.size : 0,
        filePath: typeof doc.filePath === "string" ? doc.filePath : "",
      }));

      // console.log("Fetched documents:", transformedDocs);
      setDocuments(transformedDocs);
      setError(null);
    } catch (err) {
      console.error("Error fetching documents:", err);
      setError(
        "Erro ao carregar documentos: " +
          (err.response?.data?.message || err.message)
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (doc) => {
    try {
      // console.log("Starting download for document:", doc);
      // console.log(
      //   "Download URL:",
      //   `/applications/documents/download/${doc.id}`
      // );

      const response = await http.get(
        `/applications/documents/download/${doc.id}`,
        { responseType: "blob" }
      );

      // console.log("Download response:", response);
      // console.log("Response data type:", typeof response.data);
      // console.log("Response data size:", response.data.size);

      if (!response.data || response.data.size === 0) {
        throw new Error("Document is empty or not found");
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = doc.fileName || "document";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      // console.log("Download completed successfully");
    } catch (err) {
      console.error("Error downloading document:", err);
      console.error("Error details:", err.response);
      setError(
        "Erro ao baixar documento: " +
          (err.response?.data?.message || err.message)
      );
    }
  };

  const getDocumentTypeName = (docType) => {
    // if (typeof docType === "object") {
    //   return docType.code || "Tipo Desconhecido";
    // }
    const types = {
      1: "Experiência Prévia",
      2: "Cronograma do Projecto",
    };
    return types[docType] || docType || "Tipo Desconhecido";
  };

  if (loading) {
    return <Loading description="Carregando documentos..." />;
  }

  // Create table rows with properly formatted data
  const tableRows = documents.map((doc) => ({
    id: doc.id,
    cells: [
      { id: `${doc.id}-name`, value: doc.fileName },
      { id: `${doc.id}-type`, value: getDocumentTypeName(doc.documentType) },
      {
        id: `${doc.id}-date`,
        value: doc.uploadDate
          ? new Date(doc.uploadDate).toLocaleDateString("pt-BR")
          : "-",
      },
      {
        id: `${doc.id}-size`,
        value: doc.size ? `${(doc.size / 1024 / 1024).toFixed(2)} MB` : "-",
      },
      {
        id: `${doc.id}-actions`,
        value: (
          <button
            onClick={() => handleDownload(doc)}
            className="bx--btn bx--btn--ghost bx--btn--sm"
            title="Baixar documento"
          >
            <Download32 />
          </button>
        ),
      },
    ],
  }));

  return (
    <div className="mt-2 mb-2">
      {error && (
        <InlineNotification
          kind="error"
          title="Erro"
          subtitle={error}
          onCloseButtonClick={() => setError(null)}
        />
      )}
      <FormGroup legendText="DOCUMENTOS DO PROJECTO" className="section-header">
        <Table>
          <TableHead>
            <TableRow>
              <TableHeader>Nome do Documento</TableHeader>
              <TableHeader>Tipo de Documento</TableHeader>
              <TableHeader>Tamanho</TableHeader>
              <TableHeader>Ações</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {documents.map((doc) => (
              <TableRow key={doc.id}>
                <TableCell>{doc.fileName}</TableCell>
                {/* <TableCell>{doc.documentType}</TableCell> */}
                <TableCell>
                  {getDocumentTypeDescription(doc.documentType)}
                </TableCell>
                <TableCell>
                  {doc.size ? `${(doc.size / 1024 / 1024).toFixed(2)} MB` : "-"}
                </TableCell>
                <TableCell>
                  <button
                    onClick={() => {
                      // console.log("Download button clicked for:", doc);
                      handleDownload(doc);
                    }}
                    className="bx--btn bx--btn--ghost bx--btn--sm"
                    title="Baixar documento"
                  >
                    <Download32 />
                  </button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </FormGroup>
    </div>
  );
};

export default DocumentViewer;
